import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface PaymentHistoryData {
    payment_history_idx: number;
    order_idx: number;
    customer_idx: number;
    payment_method: string;
    payment_amount: number;
    manager_name: string;
    payment_memo: string;
    payment_date: string;
    reg_date: string | null;
}

interface GetPaymentHistoryResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: PaymentHistoryData[];
}

interface GetPaymentHistoryParams {
    customerIdx: number;
    order_idx?: number;
    page?: number;
    shouldFetch?: boolean;
}

export const useGetSalesPayment = (params: GetPaymentHistoryParams): UseQueryResult<GetPaymentHistoryResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetPaymentHistoryResponse, Error>({
        queryKey: ["getPaymentHistory", params],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_sales_payment.replace(":customer_idx", params.customerIdx.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    limit: 20,
                    order_idx: params.order_idx === 0 ? null : params.order_idx,
                    page: params.page,
                },
            });
            return response.data.data;
        },
        enabled: params.shouldFetch ?? true,
        placeholderData: previousData => previousData ?? undefined,
    });
};
